/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name StaffPopupCtrl
 */
angular.module('mercury.modules.time.roster')
.controller('StaffPopupCtrl', ["dialog", "$scope", function(dialog, $scope) {
  $scope.memberFilter = {name: ''};
  $scope.selected = null;

  $scope.save = function() {
    dialog.onClose($scope.selected);
    dialog.close();
  };

  $scope.setSelected = function(selectedStaff) {
    $scope.selected = selectedStaff;
  };
}]);
